import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/gerenciamento`

    return {
        create(id) {
            return repository.get(`${baseUrl}/create/${id}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        show(id) {
            return repository.get(`${baseUrl}/${id}`)
        },
    }
}